import { Field, Section } from "./Field";
import { ImageUpload } from "./ImageUpload";

export const ProfileTab = ({ card, set }) => (
  <div className="space-y-6">
    <Section title="Immagini" hint="Logo quadrato e foto di copertina (max 5MB).">
      <ImageUpload label="Logo" value={card.logo_path} onChange={set("logo_path")} testId="upload-logo" />
      <ImageUpload label="Copertina" value={card.cover_path} onChange={set("cover_path")} testId="upload-cover" wide />
    </Section>
    <Section title="Informazioni Generali">
      <Field label="Nome azienda / Ragione sociale" value={card.company_name} onChange={set("company_name")} testId="input-company-name" />
      <Field label="Referente" value={card.contact_name} onChange={set("contact_name")} testId="input-contact-name" />
      <Field label="Ruolo" value={card.role} onChange={set("role")} testId="input-role" />
      <div className="sm:col-span-2">
        <Field label="Descrizione" value={card.description} onChange={set("description")} testId="input-description" textarea rows={4} />
      </div>
    </Section>
  </div>
);

export const ContactsTab = ({ card, set }) => (
  <Section title="Contatti & Sede">
    <Field label="Telefono" value={card.phone} onChange={set("phone")} testId="input-phone" type="tel" />
    <Field label="WhatsApp" value={card.whatsapp} onChange={set("whatsapp")} testId="input-whatsapp" type="tel" placeholder="+39 333 ..." />
    <Field label="Email" value={card.email} onChange={set("email")} testId="input-email" type="email" />
    <Field label="PEC" value={card.pec} onChange={set("pec")} testId="input-pec" type="email" placeholder="impresa@pec.it" />
    <Field label="Sito web" value={card.website} onChange={set("website")} testId="input-website" placeholder="www.tuosito.it" />
    <div className="sm:col-span-2"><Field label="Indirizzo" value={card.address} onChange={set("address")} testId="input-address" /></div>
    <div className="sm:col-span-2"><Field label="Orari di apertura" value={card.hours} onChange={set("hours")} testId="input-hours" textarea rows={3} /></div>
  </Section>
);
